module.exports = __webpack_public_path__ + "img/step4a-mobile-fr@2x.39da17f1.webp";